import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import BooksPage from "@/pages/BooksPage";
import BookDetail from "@/pages/BookDetail";
import AuthorPage from "@/pages/AuthorPage";
import AuthorJourneyPage from "@/pages/AuthorJourneyPage";
import AuthorVisitsPage from "@/pages/AuthorVisitsPage";
import LondonExplorer from "@/pages/LondonExplorer";
import AffirmationGame from "@/pages/AffirmationGame";
import DentistGame from "@/pages/DentistGame";
import SchoolGame from "@/pages/SchoolGame";
import WhatCanYouDoGame from "@/pages/WhatCanYouDoGame";
import GamesPage from "@/pages/GamesPage";
import BlogPage from "@/pages/BlogPage";
import BlogAffirmationsPost from "@/pages/BlogAffirmationsPost";
import AdminPage from "@/pages/AdminPage";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/books" element={<BooksPage />} />
            <Route path="/books/:slug" element={<BookDetail />} />
            <Route path="/author" element={<AuthorPage />} />
            <Route path="/author-journey" element={<AuthorJourneyPage />} />
            <Route path="/author-visits" element={<AuthorVisitsPage />} />
            <Route path="/london-explorer" element={<LondonExplorer />} />
            <Route path="/affirmation-game" element={<AffirmationGame />} />
            <Route path="/affirmations-game" element={<Navigate to="/affirmation-game" replace />} />
            <Route path="/dentist-game" element={<DentistGame />} />
            <Route path="/starts-school-game" element={<SchoolGame />} />
            <Route path="/what-can-you-do-game" element={<WhatCanYouDoGame />} />
            <Route path="/games" element={<GamesPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/affirmations-for-children" element={<BlogAffirmationsPost />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </CartProvider>
    </div>
  );
}

export default App;
